<template>
  <TopBarIndex :showNotification="true" />
  <div class="container pt-5">
    <div class="card mt-5">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="d-flex">
              <img class="mr-2" src="/assets/images/svg/icon/notification.svg" alt="bell">
              <h4 class="text-success">所有通知</h4>
            </div>
            <hr>
          </div>
          <div class="col-md-3 col-sm-6">
            <select-component placeholder="全部" :options="hasReadOptions" v-model="hasRead" all="全部"
              hideDefault="true"></select-component>
          </div>
          <div class="col-md-3 col-sm-6">
            <button class="btn btn-success" @click="allReadBtn">全部已讀</button>
          </div>
        </div>

        <!-- 通知清單 start -->
        <table id="table" class="table border rounded border-top-0 p-0" cellspacing="0" width="100%">
          <thead hidden>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { GetQueryString, DownloadExport } from "../../../components/helpers.js"
import { api } from "../../../apis/main.js"
import TopBarIndex from "../../../components/TopBarIndex.vue"
import SelectComponent from '../../../components/form/SelectComponent.js';
import dlang from '../../system/dlang.json'
//get_system_permission id參考
import { sub_system_index } from '../../system/config.js'
import { interfaceDeclaration } from "@babel/types";
let $ = window.$;
export default {
  name: 'NotificationView',
  props: {
  },
  components: {
    TopBarIndex,
    SelectComponent
  },
  data() {
    return {
      hasReadOptions: [
        { value: '0', text: '未讀' },
        { value: '1', text: '已讀' },
      ],
      hasRead: null,
      notes: [],
      get_total: 1,
      start_from_row: 0,
      rows_per_page: 10,
    }
  },
  async mounted() {
  },
  computed: {
    dt_data() {
     
      return this.notes.map(e => {
        let downloadLink = e.download_link == null ? '' : '<a href="javascript:void(0);"  class="download" >下載</a>';
        let r1 = e.is_read == 0 ? `<small class="fas fa-circle"></small>` : '';
        let r2 = `<input type="hidden" class="hidden-id" value="${e.id}" />
                  <input type="hidden" class="hidden-isread" value="${e.is_read}" />
                  <input type="hidden" class="hidden-download_link" value="${e.download_link}" />
                  <div class="row">
                    <div class="col-6">
                      <h4 class="text-success">
                        ${e.subsystem_name}
                        <small class="text-muted ml-2">
                          ${e.case_no?.length ? e.case_no : ''} 
                          ${e.streetlight_no?.length ? '路燈編號 ' + e.streetlight_no : ''}
                          </small>
                      </h4>
                    </div>
                    <div class="col-6 text-right my-auto">
                      <small class="text-muted">
                        ${e.updated_time?.replace('T', ' ')}
                      </small> 
                    </div>
                  </div>
                  <p>${e.subject}</p>
                  <p>${e.content} ${downloadLink}</p>`;
        return [
          r1,
          r2
        ].map(e => {
          return (e == undefined || e == null) ? '' : e;
        })
      });
    },
    queryStr() {
      let tmp = {
        get_total: this.get_total,
        start_from_row: this.start_from_row,
        rows_per_page: this.rows_per_page,
        is_read: this.hasReadStr
      }
      return GetQueryString(tmp);
    },
    hasReadStr() {
      return (this.hasRead == 'null' || this.hasRead == '') ? '' : parseInt(this.hasRead);
    }
  },
  watch: {
    hasRead(val) {
      this.setNotificationDt();
    }
  },
  methods: {

    setNotificationDt() {
      $('#table').DataTable().destroy();
      let _this = this;
      this.$nextTick(() => {
        let siteTable = $('#table').DataTable({
          language: dlang,
          searching: false,
          serverSide: true,
          processing: true,
          pageLength: 20,
          dom: "<'table-responsive'tr>" +
            "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
          bSort: true,
          columnDefs: [
            { orderable: false, targets: '_all' },
            { className: 'align-top text-center text-danger pt-3 width20', targets: 0, },
          ],
          drawCallback: function () {


            $('#table tbody td .download').on('click', function () {
              var tr = $(this).closest('tr');
              var link = tr.find('.hidden-download_link').val();
              DownloadExport(link);
            });

            $('#table tbody td').on('click', function () {
              var tr = $(this).closest('tr');
              var id = [];
              id = tr.find('.hidden-id').val();
              let isRead = tr.find('.hidden-isread').val();
              if (isRead == 0) {
                api.post('sm3_2_4?', 'ids=' + id).then(res => {
                  tr.find('.hidden-isread').val('1');
                  tr.find('.fa-circle').remove();
                })
              }
            });
          },
          ajax: (data, callback, settings) => {
            let url = `sm3_2_3?${_this.queryStr}&get_total=1`;
            url = `${url}&start_from_row=${data.start}&rows_per_page=${data.length}`

            api.post(url).then(res => {
              this.notes = res.data.data;
              let tmp = _this.dt_data;
              callback({
                data: tmp,
                recordsTotal: res.data.total_row,
                recordsFiltered: res.data.total_row,
                draw: data.draw + 1
              });
            })
          }
        });
      });
    },
    allReadBtn() {
      let ids = this.notes.filter(d => d.is_read == 0).map(e => e.id);
      if (ids.length <= 0) {
        return;
      }
      let formData = new FormData();
      ids.forEach(e => {
        if (e != null) {
          formData.append('ids', e);
        }
      });
      api.postForm('sm3_2_4?', formData).then(res => {
        this.setNotificationDt();
      })
    }
  },

}
</script>

<style >
.width20 {
  width: 20px
}
</style>
